import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './TravelPackage.css';

// Import images using require() for better compatibility
const bali = require('./Bali.png');
const baku = require('./Baku-Almaty.png'); // Renamed to avoid special character issue
const ladakh = require('./Ladakh.png');
const manalikasol = require('./Manali-Kasol.png'); // Renamed for consistency
const manalisolang = require('./Manali-Solang.png');
const spiti = require('./Spiti-valley.png');
const thailand = require('./Thailand.png');

const travelPackages = [
  { title: 'Bali', description: 'Xmas & New Year', img: bali },
  { title: 'Baku', description: 'Hunt for Northern Lights', img: baku },
  { title: 'Ladakh', description: '', img: ladakh },
  { title: 'Thailand', description: 'Celebrate New Year on the islands', img: thailand },
  { title: 'Vietnam', description: 'Stop waiting for others to say "yes"', img: manalisolang },
  { title: 'Spiti Valley', description: '', img: spiti },
];

const TravelPackages = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const scrollRef = useRef(null);
  const scrollThreshold = 200;
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.style.transform =
        scrollPosition > scrollThreshold
          ? `translateX(-${scrollPosition * 0.5}px)`
          : 'translateX(0)';
    }
  }, [scrollPosition]);

  return (
    <div
      className="mx-auto p-0 overflow-hidden"
      style={{
        background: 'linear-gradient(to bottom, #062224, white)',
      }}
    >
      <div
        ref={scrollRef}
        className="inline-flex space-x-6"
        style={{
          transition: 'transform 0.1s ease-in-out',
        }}
      >
        {travelPackages.map((pkg, index) => (
          <div
            key={index}
            onClick={() => {
              navigate(`/detail?destination=${encodeURIComponent(pkg.title)}`);
            }}
            className="parallax-card bg-white shadow-md hover:shadow-lg transition-shadow duration-300 w-80 cursor-pointer"
          >
            <div
              className="parallax-image"
              style={{
                backgroundImage: `url(${pkg.img})`,
                height: '425px',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                borderRadius: '10px',
              }}
            ></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TravelPackages;
